import {
  DownloadResultManager,
  ServiceUsingCountManager,
  ServiceUsingDurationManager,
} from "@/services/license/base/license-manager-abstractions";
import { TextToMusicCountLimiter } from "@/services/license/license-limiters/service-using-count-limiters/text-to-music-count-limiter";
import { TextToMusicDurationLimiter } from "@/services/license/license-limiters/service-using-duration-limiters/text-to-music-duration-limiter";
import { TrialDownloadResultLimiter } from "@/services/license/license-limiters/download-result-limiters/trial-download-result-limiter";

export class TextToMusicLicenseManager
  implements
    ServiceUsingCountManager,
    ServiceUsingDurationManager,
    DownloadResultManager
{
  serviceUsingCountLimiter = new TextToMusicCountLimiter();
  serviceUsingDurationLimiter = new TextToMusicDurationLimiter();
  downloadResultLimiter = new TrialDownloadResultLimiter();
}

const textToMusicLicenseManager = new TextToMusicLicenseManager();
export { textToMusicLicenseManager };
